import React, { useState, useEffect, useCallback } from "react";
import HomePage from "./Homepage";
import Aboutpage from "./AboutPage";
import ProjectsPage from "./ProjectsPage";
import CulturePage from "./CulturePage";
import ContactPage from "./ContactPage";
import MainMenu from "../Menu/mainMenu";
import TextAnimation from "./TextAnimation";
import Footer from "./Footer";
import _debounce from "lodash/debounce";

const LEN = 5;

function useDebouncedThrottle(fn, delay) {
  const debouncedFn = _debounce(fn, delay);
  return useCallback(
    function (...args) {
      debouncedFn(...args);
    },
    [debouncedFn]
  );
}

function MainHomepage() {
  const [curPage, setCurPage] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(window.innerWidth <= 1366);
    const handleResize = () => setIsMobile(window.innerWidth <= 1366);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleWheel = useDebouncedThrottle((e) => {
    let delta = e.deltaY || e.wheelDelta;
    if (delta > 0) {
      setCurPage((prevPage) => Math.min(prevPage + 1, LEN - 1));
    } else {
      setCurPage((prevPage) => Math.max(prevPage - 1, 0));
    }
  }, 50);

  const navigateToAbout = () => setCurPage(1);
  const navigateToHome = () => setCurPage(0);

  return (
    <>
      <MainMenu />
      <div className="Homepage">
        {!isMobile ? (
          <div className="container" onWheel={(e) => handleWheel(e)}>
            <div
              className="full-page"
              style={{
                position: "relative",
                height: "100%",
                transform: `translateY(-${curPage * 100}%)`,
                transition: "transform 0.7s ease-in-out",
              }}
            >
              <div className="page">
                <HomePage onNavigateToAbout={navigateToAbout} />
              </div>
              <div className="page">
                <Aboutpage />
              </div>
              <div className="page">
                <ProjectsPage />
              </div>
              <div className="page">
                <CulturePage />
              </div>
              <div className="page">
                <ContactPage />
              </div>
            </div>
          </div>
        ) : (
          <>
            <section>
              <div className="pageMB">
                <HomePage onNavigateToAbout={navigateToAbout} />
              </div>
            </section>
            <section>
              <div className="pageMB">
                <Aboutpage />
              </div>
            </section>
            <section>
              <div className="pageMB">
                <ProjectsPage />
              </div>
            </section>
            <section>
              <div className="pageMB">
                <CulturePage />
              </div>
            </section>
            <section>
              <div className="pageMB">
                <ContactPage />
              </div>
            </section>
          </>
        )}
      </div>
      <TextAnimation
        onNavigateToHome={navigateToHome}
        curPage={curPage}
        isMobile={isMobile}
      />
      <Footer />
    </>
  );
}

export default MainHomepage;
